import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';
import reportWebVitals from 'reportWebVitals';

/* eslint-disable */
import { groupBy } from "core-js/actual/array/group-by";

// router
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux'
import { store } from 'Store'

import ScrollToTop from 'Util/scroll_top';
import { HelmetProvider } from 'react-helmet-async';

// expose store globally for legacy Service helper usage
if (typeof window !== 'undefined') window.store = store;

const container = document.getElementById('app');
const root = ReactDOM.createRoot(container);

root.render(
  <BrowserRouter>
      <Provider store={store}>
        <ScrollToTop />
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
